import { render, staticRenderFns } from "./TaskBoard.vue?vue&type=template&id=be7c1418&scoped=true&"
import script from "./TaskBoard.vue?vue&type=script&lang=js&"
export * from "./TaskBoard.vue?vue&type=script&lang=js&"
import style0 from "./TaskBoard.vue?vue&type=style&index=0&id=be7c1418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7c1418",
  null
  
)

export default component.exports